module.exports = __webpack_public_path__ + "static/media/chevron-up-white.259da4d5.svg";